<div class="bolt-container-fluid tm-content-container">
  @for (vehicle of vehicles; track vehicle.vehicleId; let i = $index) {
    <div>
      <nwx-telematics-vehicle-premium
        [vehicle]="vehicle"
        [vehicleIndex]="i"
        [currentProgram]="'NotEnrolled'"
        [allowChange]="false"
        [enrollment]="enrollment"
      ></nwx-telematics-vehicle-premium>
    </div>
  }
</div>
